import type { Issue } from '../types/issue';

// CSV-Parser (RFC 4180 + JIRA-Quirks): unterstützt Quoting mit "" als Escape,
// CRLF, BOM. Identisch zur Logik aus V1.
export function parseCSV(text: string): string[][] {
  if (text.charCodeAt(0) === 0xFEFF) text = text.slice(1);
  const out: string[][] = [];
  let row: string[] = [];
  let field = '';
  let i = 0;
  let inQuotes = false;
  while (i < text.length) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i += 2; continue; }
        inQuotes = false; i++; continue;
      }
      field += c; i++; continue;
    } else {
      if (c === '"') { inQuotes = true; i++; continue; }
      if (c === ',') { row.push(field); field = ''; i++; continue; }
      if (c === '\r') { i++; continue; }
      if (c === '\n') { row.push(field); out.push(row); row = []; field = ''; i++; continue; }
      field += c; i++;
    }
  }
  if (field.length || row.length) { row.push(field); out.push(row); }
  return out.filter(r => r.some(c => c && c.length));
}

// Header → Objekt. Duplikat-Header (Fix versions, Sprint, Labels) werden
// zu Arrays zusammengefasst (Jira exportiert mehrere Werte als
// gleich-benannte Spalten nebeneinander).
export function buildRows(matrix: string[][]): Issue[] {
  if (!matrix.length) return [];
  const headers = matrix[0].map(h => h.trim());
  const counts: Record<string, number> = {};
  headers.forEach(h => { counts[h] = (counts[h] || 0) + 1; });

  const rows: Issue[] = [];
  for (let r = 1; r < matrix.length; r++) {
    const obj: Record<string, unknown> = {};
    const arr = matrix[r];
    for (let c = 0; c < headers.length; c++) {
      const h = headers[c];
      const v = (arr[c] || '').trim();
      if (counts[h] > 1) {
        if (!obj[h]) obj[h] = [];
        if (v) (obj[h] as string[]).push(v);
      } else {
        obj[h] = v;
      }
    }
    rows.push(obj as Issue);
  }
  return rows;
}

export async function parseCsvFile(file: File): Promise<Issue[]> {
  const text = await file.text();
  return buildRows(parseCSV(text));
}

// Mehrere CSV-Dateien zusammen mergen. Dedup nach Issue key.
// Bei gleichem Key gewinnt der spätere (also: weiter unten in der File-Liste).
export function mergeIssueLists(lists: Issue[][]): Issue[] {
  const map = new Map<string, Issue>();
  for (const list of lists) {
    for (const r of list) {
      const k = r['Issue key'];
      if (typeof k === 'string' && k) map.set(k, r);
    }
  }
  return Array.from(map.values());
}
